import * as React from "react";
import { Box, PlatformPageDialog } from "@platform/style";
import WorkGroupsGrid from "./WorkGroupsGrid";

export function WorkGroups() {
  return (
    <PlatformPageDialog
      title={"Work Groups"}
      eventName={"WorkGroups"}
      showPageHeader={true}
      showCloseIcon={false}
      keepMounted={false}
    >
      <Box
        sx={{
          height: "100%",
          display: "flex",
          flexDirection: "column",
          backgroundColor: "inherit",
        }}
      >
        <WorkGroupsGrid />
      </Box>
    </PlatformPageDialog>
  );
}
